import React from 'react';
import ProcessBooleanField from './ProcessBooleanField';

export default function FiscalChatVisibility({ value, onChange }) {
    return <ProcessBooleanField id="show-fiscal-chat" value={value !== false} onChange={onChange}
        label="Exibir chat do fiscal para o candidato"
        help="Controla a exibição do chat flutuante para o candidato. As liberações, a pausa, a câmera externa e as chamadas de vídeo seguem as demais configurações." />;
}
